import {
	SociosSocketEvent,
	UseCredentialsQueryKeys,
	useSocketManager,
	UseUserQueryKeys,
	withRefreshStrategy
} from '@capsicum/common';
import { useUser } from '@capsicum/socios-core';

/**
 * Hook that stops listening to user:cache:invalidate WS event and adds it again after the component unmounts.
 */
export const useCredentialsWebSockets = () => {
	const { refetchUser } = useUser();

	// eslint-disable-next-line no-restricted-syntax -- This is a custom hook, it needs to use getSockets directly.
	const { getSockets } = useSocketManager();
	const { socios } = getSockets();

	const removeCredentialsWebSocketsListener = () => {
		socios?.removeAllListeners(SociosSocketEvent.INVALIDATE_USER_CACHE);
	};

	const resetCredentialsWebSocketsListener = () => {
		setTimeout(() => {
			socios?.addListener(
				SociosSocketEvent.INVALIDATE_USER_CACHE,
				withRefreshStrategy({
					cacheKeys: [...UseCredentialsQueryKeys, ...UseUserQueryKeys],
					listener: refetchUser
				})
			);
		}, 1000);
	};

	return { removeCredentialsWebSocketsListener, resetCredentialsWebSocketsListener };
};
